import {
  assignQcTaskQcTasksAssignPatch,
  AssignQcTaskQcTasksAssignPatchResponse,
  Body_assign_qc_task_qc_tasks_assign_patch,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useAssignTasksMutation = (): UseMutationResult<
  AssignQcTaskQcTasksAssignPatchResponse,
  AxiosError<HTTPValidationError>,
  Body_assign_qc_task_qc_tasks_assign_patch
> => {
  return useMutation<
    AssignQcTaskQcTasksAssignPatchResponse,
    AxiosError<HTTPValidationError>,
    Body_assign_qc_task_qc_tasks_assign_patch
  >({
    mutationFn: async (body) => {
      const response = await assignQcTaskQcTasksAssignPatch({
        body: body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['QCTasksList'] })
    },
  })
}
